/**
 * Functions related to sticky header functionality
 *
 * @return void
 */

import {body, header, stickyHeaderClass} from './helpers';

export const stickyHeader = () => {
	let scrollObject = {};
	const stickPoint = getHeaderDistance();


	window.onscroll = getScrollPosition;
	document.body.addEventListener('touchmove', getScrollPosition);

	function getScrollPosition() {
		scrollObject = {
			x: window.scrollX,
			y: window.scrollY
		};

		if (stickPoint < scrollObject.y || stickPoint < document.body.scrollTop) {
			body.classList.add(stickyHeaderClass);
		} else {
			body.classList.remove(stickyHeaderClass);
		}
	}

	function getHeaderDistance() {
		return header.offsetTop;
	}

	// window.addEventListener('scroll', onScroll);
	// document.body.addEventListener('touchmove', onScroll);
	//
	// function onScroll( e ) {
	// 	console.log('scrolling');
	// 	const distance = stickPoint - scrollY;
	// 	const offset   = scrollY;
	//
	// 	// console.log('distance: ', distance);
	// 	// console.log('offset: ', offset);
	// 	console.log('stickPoint', stickPoint);
	// 	console.log('🚧🚧🚧🚧🚧🚧🚧🚧🚧🚧🚧🚧');
	//
	// 	if ( (0 >= distance) && ! stuck ) {
	// 		stuck = true;
	// 		body.classList.add( stickyHeaderClass );
	// 	} else if ( stuck && (offset <= stickPoint) ) {
	// 		stuck = false;
	// 		body.classList.remove( stickyHeaderClass );
	// 	}
	// }



};
